export const TAG_MANAGER_ARG = {
  gtmId: process.env.REACT_APP_GTM_ID as string,
};
